import React, { useState } from 'react';
import { motion } from 'framer-motion';

const BulletIcon = () => (
	<img 
		src="/images/arrow-bulltin.png" 
		alt="Arrow bullet point"
		className="flex-shrink-0 w-8 h-8"
	/>
);

const DEFAULT_SIDE_IMAGE = '/images/glass-image.png';

const WhyWorkWithUs = () => {
	const [sideImage, setSideImage] = useState(DEFAULT_SIDE_IMAGE);

	return (
		<section className="relative bg-white">
			<div className="max-w-full mx-auto px-6 sm:px-8 md:px-12 py-10 md:py-14">
			<motion.img
							src={sideImage}
							onError={() => setSideImage('/images/color-wires.png')}
							alt="Colored cables with connector"
							className="hidden md:block absolute select-none pointer-events-none"
							style={{
								width: '35vw',
								top: '50px',
								left: '-40px',
								height: '700px',
								objectFit: 'cover',
								rotate: '5deg',
								
								
							}}
							initial={{ y: 10, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.6, ease: 'easeOut' }}
						/>
				<div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 max-w-7xl mx-auto">
					{/* Left column */}
					<div className="md:col-span-5 relative">
						<div className="max-w-sm">
							<h2 className="text-3xl md:text-4xl font-semibold text-[#113861]">
								<span className="font-source italic font-regular text-4xl md:text-5xl text-[#113861]">Why</span>{' '}
								<span className="text-[#113861] font-source font-light">work with us</span>
							</h2>
							<p className="mt-6 text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular">
								Joining Analytical Prism means being part of a mission-driven organization that values:
							</p>
						</div>
						{/* Side decorative image with exact positioning */}
					
					</div>

					{/* Right column bullets */}
					<div className="md:col-span-7 md:border-l md:border-gray-200 md:pl-10">
						<ul className="space-y-6">
							<li className="flex items-start gap-3">
								<BulletIcon />
								<div>
									<p className="mt-1 font-semibold text-[#2b2b2b] font-sans font-regular">Innovation</p>
									<p className="mt-1 text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular">
										We are committed to advancing the frontiers of science and technology by developing solutions that make a meaningful difference across various fields.
									</p>
								</div>
							</li>
							<li className="flex items-start gap-3">
								<BulletIcon />
								<div>
									<p className="mt-1 font-semibold text-[#2b2b2b] font-sans font-regular">Collaboration</p>
									<p className="mt-1 text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular">
										Our organization values diverse perspectives, acknowledging that innovative ideas often emerge from collaborative discussions and teamwork. We encourage open dialogue as a vital component of fostering creativity and driving success.
									</p>
								</div>
							</li>
							<li className="flex items-start gap-3">
								<BulletIcon />
								<div>
									<p className="mt-1 font-semibold text-[#2b2b2b] font-sans font-regular">Purpose-Driven Work</p>
									<p className="mt-1 text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular">
										Each project we undertake is designed to improve quality of life through data-driven insights derived from research and evidence.
									</p>
								</div>
							</li>
							<li className="flex items-start gap-3">
								<BulletIcon />
								<div>
									<p className="mt-1 font-semibold text-[#2b2b2b] font-sans font-regular">Career Growth</p>
									<p className="mt-1 text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular">
										We are dedicated to investing in our employees by offering a range of opportunities that promote continuous learning, skill enhancement, and leadership development. These initiatives are intended to support both personal and professional growth, ensuring that our workforce remains skilled and prepared for future challenges.
									</p>
								</div>
							</li>
							<li className="flex items-start gap-3">
								<BulletIcon />
								<div>
									<p className="mt-1 font-semibold text-[#2b2b2b] font-sans font-regular">Supportive Culture</p>
									<p className="mt-1 text-[13px] leading-6 text-[#2b2b2b] font-sans font-regular">
										Our work environment fosters curiosity and creativity while emphasizing a shared commitment to excellence. If you are passionate about scientific research, human development, and creating meaningful change, we would love to have you on board.
									</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default WhyWorkWithUs;


